var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "reporting-main-container" },
    [
      _c("ReportingInsightsSettings", {
        staticClass: "reporting-settings-container",
        on: {
          onStartTour: _vm.userTriggerStartTour,
          dateRangeChange: _vm.handleDateRangeChange
        }
      }),
      _vm._v(" "),
      _vm.activeInsightSelectedGroupBy && _vm.activeInsightSelectedGroupBy.field
        ? _c(
            "div",
            { staticClass: "reporting-grid-data" },
            [
              _c("ReportingGridHeader", {
                staticClass: "reporting-insights__grid-header",
                attrs: {
                  "selected-chart-type": _vm.selectedChartType,
                  "selected-group-by": _vm.activeInsightSelectedGroupBy,
                  "available-group-bys": _vm.availableGroupBys
                },
                on: {
                  onChartTypeChange: _vm.onSelectChartType,
                  onGroupByChange: _vm.onGroupByChange,
                  onDeleteGroupBy: _vm.onDeleteGroupBy,
                  exportSelectCols: function($event) {
                    return _vm.onExportFull(false)
                  },
                  exportFull: function($event) {
                    return _vm.onExportFull(true)
                  },
                  openQuickInsightsToolPanel: _vm.toggleQuickInsightsToolPanel
                }
              }),
              _vm._v(" "),
              _c("ReportingGrid", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.selectedChartType === "table",
                    expression: "selectedChartType === 'table'"
                  }
                ],
                attrs: {
                  "group-by": _vm.activeInsightSelectedGroupBy,
                  "open-columns-panel": _vm.openGridColumnToolPanel,
                  "toggle-quick-insights-panel": _vm.toggleQuickInsightsPanel,
                  "initial-expand-all-groups": _vm.initialExpandAllGroups
                },
                on: {
                  onGridTopLevelDataLoaded: _vm.onGridTopLevelDataLoaded,
                  cellClicked: _vm.onCellClicked
                }
              }),
              _vm._v(" "),
              _c("ReportingCharts", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.selectedChartType !== "table",
                    expression: "selectedChartType !== 'table'"
                  }
                ],
                staticClass: "m-10",
                attrs: {
                  "chart-type": _vm.selectedChartType,
                  "group-by": _vm.activeInsightSelectedGroupBy,
                  "selected-group-by": _vm.activeInsightSelectedGroupBy
                },
                on: { getChartDrilldownData: _vm.onChartDrilldown }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("v-tour", {
        attrs: {
          name: "insightTour",
          steps: _vm.steps,
          options: { highlight: true },
          callbacks: _vm.tourCallbacks
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(tour) {
              return [
                _c(
                  "transition",
                  { attrs: { name: "fade" } },
                  _vm._l(tour.steps, function(step, index) {
                    return tour.currentStep === index
                      ? _c(
                          "v-step",
                          {
                            key: index,
                            attrs: {
                              step: step,
                              "previous-step": tour.previousStep,
                              "next-step": tour.nextStep,
                              stop: tour.stop,
                              "is-first": tour.isFirst,
                              "is-last": tour.isLast,
                              labels: tour.labels,
                              highlight: tour.highlight
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "v-step__header",
                                attrs: { slot: "header" },
                                slot: "header"
                              },
                              [
                                _c("span"),
                                _vm._v(" "),
                                _c("span", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      step.header ? step.header.title : ""
                                    )
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.dontShowTourAgain(
                                          tour.currentStep
                                        )
                                      }
                                    }
                                  },
                                  [_c("i", { staticClass: "fa fa-times" })]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { attrs: { slot: "actions" }, slot: "actions" },
                              [
                                !tour.isFirst
                                  ? _c("button", {
                                      directives: [
                                        {
                                          name: "t",
                                          rawName: "v-t",
                                          value: "TOUR_PREVIOUS",
                                          expression: "'TOUR_PREVIOUS'"
                                        }
                                      ],
                                      staticClass:
                                        "btn btn-default btn-default--vue-tour btn-sm m-r-5",
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          return tour.previousStep.apply(
                                            null,
                                            arguments
                                          )
                                        }
                                      }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                !tour.isLast
                                  ? _c("button", {
                                      directives: [
                                        {
                                          name: "t",
                                          rawName: "v-t",
                                          value: "TOUR_NEXT",
                                          expression: "'TOUR_NEXT'"
                                        }
                                      ],
                                      staticClass: "btn btn-primary btn-sm",
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          return tour.nextStep.apply(
                                            null,
                                            arguments
                                          )
                                        }
                                      }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                tour.isLast
                                  ? _c("button", {
                                      directives: [
                                        {
                                          name: "t",
                                          rawName: "v-t",
                                          value: "TOUR_FINISH",
                                          expression: "'TOUR_FINISH'"
                                        }
                                      ],
                                      staticClass: "btn btn-primary btn-sm",
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          return tour.finish.apply(
                                            null,
                                            arguments
                                          )
                                        }
                                      }
                                    })
                                  : _vm._e()
                              ]
                            )
                          ]
                        )
                      : _vm._e()
                  }),
                  1
                )
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }